import InstantClick from 'instantclick'

(($) => {

    'use strict'

    $('article img').each((index, el) => {
    	$(el).parent('a').removeAttr('href')
    })

})(jQuery)
